import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const ROLE = ensureStatuses({
	SWIFTCAST: {
		id: 167,
		name: 'Swiftcast',
		icon: iconUrl(210454),
		duration: 10000,
	},

	LUCID_DREAMING: {
		id: 1204,
		name: 'Lucid Dreaming',
		icon: iconUrl(213909),
		duration: 21000,
	},

	SURECAST: {
		id: 160,
		name: 'Surecast',
		icon: iconUrl(210452),
		duration: 6000,
	},

	RAMPART: {
		id: 1191,
		name: 'Rampart',
		icon: iconUrl(210152),
		duration: 20000,
	},

	REPRISAL: {
		id: 1193,
		name: 'Reprisal',
		icon: iconUrl(213901),
		duration: 15000,
	},

	ARMS_LENGTH: {
		id: 1209,
		name: 'Arm\'s Length',
		icon: iconUrl(213915),
		duration: 6000,
	},

	ADDLE: {
		id: 1203,
		name: 'Addle',
		icon: iconUrl(213917),
		duration: 15000,
	},

	BLOODBATH: {
		id: 84,
		name: 'Bloodbath',
		icon: iconUrl(213913),
		duration: 20000,
	},

	FEINT: {
		id: 1195,
		name: 'Feint',
		icon: iconUrl(213904),
		duration: 15000,
	},

	TRUE_NORTH: {
		id: 1250,
		name: 'True North',
		icon: iconUrl(213903),
		duration: 10000,
	},
})
